import React from 'react';
import { formatCurrency } from 'utils';
import { NO_DATA } from 'constants/common';
import { getAssetUrl } from 'utils/getAssetUrl';
import { ConditionBadge } from 'modules/equipment';
import { ImageViewer } from 'components/shared/Image';
import { Launch, Speed, Tag, Grid3x3 } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Nullable } from 'global';

export interface EquipmentCardData {
  id: string;
  assets: Array<{ id: string; source: string }>;
  price: {
    wholesaleCost: Nullable<number>;
  };
  details: {
    name: string;
    vin: string;
    mileage: string;
    stockId: string;
    condition: string;
    description: string;
  };
}

interface Props {
  equipment: EquipmentCardData;
  onViewUnit: (equipmentId: string) => void;
}

export const EquipmentCardContent = ({ equipment, onViewUnit }: Props) => (
  <>
    <Stack gap="0.3rem" sx={{ flex: 5 }}>
      <Stack direction="row" justifyContent="space-between" flexWrap="wrap">
        <Stack direction="row" alignItems="center" gap="0.5rem" flexWrap="wrap">
          <Typography variant="h6">{equipment.details.name}</Typography>
          <ConditionBadge condition={equipment.details.condition} />
        </Stack>

        <Typography>
          List Price:{' '}
          {equipment.price.wholesaleCost !== null ? formatCurrency(equipment.price.wholesaleCost, true) : NO_DATA}
        </Typography>
      </Stack>

      <Stack direction="row" gap="1rem" flexWrap="wrap">
        <Stack direction="row" gap="0.3rem">
          <Tag fontSize="small" />
          <Typography>VIN: {equipment.details.vin || NO_DATA}</Typography>
        </Stack>
        <Stack direction="row" gap="0.3rem">
          <Speed fontSize="small" />
          <Typography>{equipment.details.mileage || NO_DATA}</Typography>
        </Stack>
        <Stack direction="row" gap="0.3rem">
          <Grid3x3 fontSize="small" />
          <Typography>Stock #:{equipment.details.stockId || NO_DATA}</Typography>
        </Stack>
      </Stack>

      {equipment.details.description && (
        <Stack>
          <Typography variant="caption">Vehicle Description:</Typography>
          <Typography variant="body1">{equipment.details.description}</Typography>
        </Stack>
      )}
    </Stack>

    <Box gap="0.3rem" sx={{ flex: 1, minWidth: '12rem' }}>
      <ImageViewer url={equipment.assets?.[0]?.source ? getAssetUrl(equipment.assets[0].source) : ''} />
    </Box>

    <Button
      size="small"
      endIcon={<Launch color="primary" />}
      onClick={e => {
        e.stopPropagation();
        onViewUnit(equipment.id);
      }}
    >
      View Unit
    </Button>
  </>
);
